import React, { Component } from 'react';
import { Container, Row, Button, Col } from 'react-bootstrap';
import Datetime from 'react-datetime';

export default class ProjEditTimeDom extends React.Component {
    constructor(props) {
        super(props);

        // this.state = {
        //     value: props.value
        // };
        this.onChange = this.onChange.bind(this);
    }

    onChange(event) {
        console.log(event, event.valueOf());
        if (event) {
            this.props.onChange(this.props.dataKey, event.valueOf());
        }
    }

    render() {
        const { isDisabled, data, value } = this.props;
        // const { value } = this.state;

        if (isDisabled) {
            return (
                <Col className="mb-2">
                    <label>{data.name}</label>
                    {/* <input disabled="disabled" className="form-control" type="text" placeholder="xxx" value={value} /> */}
                    <Datetime
                        dateFormat={'YYYY/MM/DD'}
                        timeFormat={false}
                        defaultValue={new Date()}
                        // disabled
                        onChange={this.onChange}
                        value={value ? new Date(value) : null}
                        inputProps={{ placeholder: 'N/A', disabled: true }}
                    />
                </Col>
            );
        } else {
            return (
                <Col className="mb-2">
                    <label>{data.name}</label>
                    {/* <input className="form-control" type="text" placeholder="xxx" value={value} onChange={this.onChange} /> */}
                    <Datetime
                        dateFormat={'YYYY/MM/DD'}
                        timeFormat={false}
                        onChange={this.onChange}
                        value={new Date(value)}
                    />
                </Col>
            );
        }

    }
}